/* eslint-disable react/no-unknown-property */
export const PremiumStarIcon = ({size = 16}: {size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99992 11.5134L12.1199 14L11.0266 9.31337L14.6666 6.16004L9.87325 5.74671L7.99992 1.33337L6.12658 5.74671L1.33325 6.16004L4.96658 9.31337L3.87992 14L7.99992 11.5134Z"
        fill="white"
      />
      <path
        d="M7.99992 11.5134L12.1199 14L11.0266 9.31337L14.6666 6.16004L9.87325 5.74671L7.99992 1.33337L6.12658 5.74671L1.33325 6.16004L4.96658 9.31337L3.87992 14L7.99992 11.5134Z"
        fill="url(#paint0_linear_4415_96)"
        fillOpacity="0.5"
      />
      <path
        d="M7.99992 11.5134L12.1199 14L11.0266 9.31337L14.6666 6.16004L9.87325 5.74671L7.99992 1.33337L6.12658 5.74671L1.33325 6.16004L4.96658 9.31337L3.87992 14L7.99992 11.5134Z"
        fill="url(#paint1_linear_4415_96)"
      />
      <path
        d="M9.41333 5.94177L9.53052 6.21912L9.83032 6.24451L13.4446 6.55603L10.6995 8.93591L10.4709 9.13318L10.5393 9.42712L11.3635 12.9594L8.25806 11.0853L8.00024 10.9291L7.74146 11.0853L4.63403 12.9594L5.45337 9.42615L5.52173 9.13318L5.29419 8.93591L2.55298 6.55603L6.16919 6.24451L6.46899 6.21912L6.58716 5.94177L7.99927 2.61267L9.41333 5.94177Z"
        stroke="url(#paint2_linear_4415_96)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4415_96"
          x1="5.80814"
          y1="1.33338"
          x2="14.7863"
          y2="5.44628"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D5E7FF" />
          <stop offset="1" stop-color="#FFE3FC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4415_96"
          x1="4.25563"
          y1="0.654803"
          x2="14.0758"
          y2="5.68716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#93C5FD" />
          <stop offset="1" stop-color="#DE8EDF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4415_96"
          x1="4.25563"
          y1="0.654803"
          x2="14.0758"
          y2="5.68716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#93C5FD" />
          <stop offset="1" stop-color="#DE8EDF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
